// "Sohbeti dogrudan ac" tetikleyicisinin karsilama balonu. Sunucuya yazilmaz, sadece ziyaretciye gosterilir.
// CommonJS: webpack de node --test de okuyabilsin diye.

const WELCOME_ID = "trigger-welcome";

function clean(v) {
    return typeof v === "string" ? v.trim() : "";
}

function buildTriggerWelcome(payload, now) {
    const text = clean(payload && payload.html) || clean(payload && payload.title);
    if (!text) return null;
    return {
        messageType: "user",
        description: text,
        createdDate: now,
        uniqMessageId: WELCOME_ID,
        isTriggerWelcome: true,
    };
}

// Karsilama en son mesaj olarak gorunur; gecmisi olan ziyaretcide de sona duser.
function withTriggerWelcome(messages, welcome) {
    return welcome ? [...messages, welcome] : messages;
}

module.exports = { buildTriggerWelcome, withTriggerWelcome, WELCOME_ID };



// WEBPACK FOOTER //
// ./src/utils/triggerWelcome.js